import { request, API_V1_PREFIX } from "./client";
import type { EnrollmentData } from "./types";

export async function enrollStudent(
  classId: string,
  studentId: string,
  token: string,
  schoolProfileId?: string,
): Promise<EnrollmentData> {
  return request<EnrollmentData>(
    `${API_V1_PREFIX}/enrollments`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        class_id: classId,
        student_id: studentId,
        status: "active",
        school_profile_id: schoolProfileId,
      }),
    },
    { token },
  );
}

export async function getEnrollments(token: string, schoolProfileId?: string): Promise<EnrollmentData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<EnrollmentData[]>(`${API_V1_PREFIX}/enrollments${query}`, { method: "GET" }, { token });
}

export async function deleteEnrollment(id: string, token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/enrollments/${id}`, { method: "DELETE" }, { token });
}
